import * as React from "react";
import {Column, useSortBy, useTable} from "react-table";
import InfiniteScroll from "react-infinite-scroll-component";
import {Loader} from "../../../../../components/Utils/loader/Loader";
import "./styles.scss";
import {Icon, SpinnerSize} from "@vebox/etui-core";
import {Display} from "../../../../../components/Display";

export interface InfiniteScrollTableProps {
    columns: readonly Column<any>[];
    data: Array<any>;
    update: () => void;
    hasNextPage: boolean;
    emptyPlaceholder?: React.ReactNode;
    isLoading?: boolean;
    height: string;
    scrollThreshold?: string | number;
}

export const InfiniteScrollTable: React.FC<InfiniteScrollTableProps> = ({
                                                                            columns,
                                                                            data,
                                                                            update,
                                                                            hasNextPage,
                                                                            emptyPlaceholder,
                                                                            isLoading,
                                                                            height,
                                                                            scrollThreshold,
                                                                        }) => {
    const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} =
        useTable(
            {
                columns,
                data,
            },
            useSortBy,
        );

    // Render the UI for your table
    return (
        <>
            <Display isVisible={isLoading && rows?.length === 0}>
                <div className={"loader-table-container"}>
                    <Loader relativelyCentered={true} spinnerSize={2}/>
                </div>
            </Display>
            <Display isVisible={!isLoading && rows?.length === 0}>
                {emptyPlaceholder}
            </Display>
            <Display isVisible={rows?.length > 0}>
                <div id={"container"} style={{height: height}}>
                    <InfiniteScroll
                        dataLength={rows.length}
                        next={update}
                        hasMore={hasNextPage}
                        loader={
                            <Loader
                                relativelyCentered={true}
                                spinnerSize={SpinnerSize.small}
                            />
                        }
                        style={{overflow: "unset"}}
                        scrollThreshold={scrollThreshold ?? 0.5}
                        scrollableTarget={"container"}
                    >
                        <table {...getTableProps()}>
                            <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps(
                                                // @ts-ignore
                                                column.getSortByToggleProps(),
                                            )}
                                        >
												<span style={{display: "flex", fontWeight: "bold"}}>
													{column.render("Header")}
                                                    <span>
														{/*@ts-ignore*/}
                                                        {column.isSorted ? (
                                                            // @ts-ignore
                                                            column.isSortedDesc ? (
                                                                <Icon
                                                                    symbol={"arrow_downward"}
                                                                    weight={"300"}
                                                                />
                                                            ) : (
                                                                <Icon symbol={"arrow_upward"} weight={"300"}/>
                                                            )
                                                        ) : (
                                                            ""
                                                        )}
													</span>
												</span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>

                            <tbody {...getTableBodyProps()}>
                            {rows.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <td {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </InfiniteScroll>
                </div>
            </Display>
        </>
    );
};
